module.exports = __webpack_public_path__ + "img/diente74.ecac3ddd.png";